export const AUTHORIZED_USER_IDS = [2200, 2794] as const;

export const ACCESS_DENIED_MESSAGE =
  "Bạn không có quyền truy cập, vui lòng liên hệ quản trị viên.";

export const AUTH_STORAGE_KEYS = {
  token: "assistant-admin.token",
  companyId: "assistant-admin.company-id",
  user: "assistant-admin.user",
  profile: "assistant-admin.profile",
  roleTitle: "assistant-admin.role-title",
} as const;

export function extractUserId(profile: Record<string, unknown> | null | undefined): number | null {
  const rawId = profile?.id;

  if (typeof rawId === "number" && Number.isFinite(rawId)) {
    return rawId;
  }

  if (typeof rawId === "string" && rawId.trim()) {
    const parsed = Number(rawId);
    return Number.isFinite(parsed) ? parsed : null;
  }

  return null;
}

export function isAuthorizedUserId(userId: number | null | undefined): boolean {
  return userId != null && AUTHORIZED_USER_IDS.includes(userId as (typeof AUTHORIZED_USER_IDS)[number]);
}
